import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;
const { TextArea } = Input;

const mapPropsToFields = ({ dataSource }) => {
  const { obfuscated_text, hidden } = dataSource;
  return {
    obfuscated_text: Form.createFormField({ obfuscated_text }),
    hidden: Form.createFormField({ hidden })
  };
};
const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const {
    hidden, obfuscated_text
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Comment">
        {
          getFieldDecorator('obfuscated_text', {
            initialValue: obfuscated_text,
            rules: [{
              required: true,
              message: 'Please enter a comment.'
            }]
          })(<TextArea disabled={readonly} rows={4} />)
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('hidden', {
            initialValue: hidden,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Hidden
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const CommentInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default CommentInput;
